export function ellipsis(string: string, number = 100) {
  const ellipsisUnicode = '\u2026';

  if (string) {
    const sub = string.substring(0, number);
    if (sub.length < string.length) {
      return `${sub.trim()}${ellipsisUnicode}`;
    }
  }
  return string;
}

export function capitalizeFirstLetter(string: string) {
  return string.replace(/^\w/, (c: string) => c.toUpperCase());
}

export function replace(str: string, replacement: string, regex: RegExp) {
  return str.replace(regex, replacement);
}

export function formatNumber(number: number, locales = 'de') {
  if (number) {
    return new Intl.NumberFormat(locales).format(number);
  }

  return '';
}

const htmlEntitiesMap = [
  ['&amp;', '&'],
  ['&apos;', '\''],
  ['&#x27;', '\''],
  ['&lt;', '<'],
  ['&gt;', '>'],
  ['&lsquo;', '‘'],
  ['&rsquo;', '’'],
  ['&sbquo;', '‚'],
  ['&ldquo;', '“'],
  ['&rdquo;', '”'],
  ['&bdquo;', '„'],
  ['&quot;', '"'],
];

export function decodeHtmlEntities(s: string) {
  return s.replace(/&#?(\w+);/g, (match) => {
    const htmlEntity = htmlEntitiesMap.find(([key]) => key === match);
    if (htmlEntity) {
      return htmlEntity[1];
    }

    return match;
  });
}

export function removeControlCharacters(s?: string): string | undefined {
  if (!s) {
    return s;
  }

  // Keep newlines, carriage returns and tabs intact
  // eslint-disable-next-line no-control-regex
  return s.replace(/\s?[\x00-\x08\x0B\x0C\x0E-\x1F]/g, '');
}
